import React from 'react';
import { InView } from 'react-intersection-observer';

import SignInOption from '@components/Form/EmailForm/SignInOption';
import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';

import { PaywallProps } from '.';
import PaywallForm from './Form';

const PaywallFull = (paywallProps: PaywallProps): JSX.Element => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.Paywall });
  return (
    <aside
      className="sticky -bottom-px z-50 mt-0 w-full bg-grayscale-charcoal"
      data-testid="paywall"
    >
      <Track>
        <InView
          triggerOnce={true}
          onChange={(inView) => {
            inView && trackEvent(impression({ impressionElement: ImpressionElement.PaywallFull }));
          }}
        >
          <SignInOption className="mb-16 pt-16 text-center font-suisse-screen text-disclosure-sm text-grayscale-beige md:mb-48 md:pt-24" />
          <PaywallForm {...paywallProps} />
        </InView>
      </Track>
    </aside>
  );
};

export default PaywallFull;
